module.exports = __webpack_public_path__ + "img/disks.27a237e6.svg";